import {
  checkIsIdleArm,
  checkSamePosition,
} from 'containers/selfe-booth/shooting-position/shooting-position-helper';
import { useBoothAppContext } from 'context/BoothAppContext';
import useBeautifulReactDebouncedCallback from 'beautiful-react-hooks/useDebouncedCallback';
import { useCallback } from 'react';
import {
  useGoToRobotArmHomePositionApiActionMutation,
  useLazyGetRobotArmPositionApiActionQuery,
  useLazyGetRobotArmStatusApiActionQuery,
  useUpdateRobotArmPositionApiActionMutation,
} from 'store/api/robot-arm.slice-api';
import { useAppSelector } from 'store/store-hooks';
import { TIME_DEBOUNCE_UPDATE_ROBOT_ARM } from 'constants/photo.const';
import { RobotArmPositionWithCaptureNameModel } from 'models/photo/robot-arm.model';

type UseRobotArmProps = {};

export function useRobotArmHandler({}: UseRobotArmProps = {}) {
  const { listCapturePosition } = useBoothAppContext();
  // Robot Arm
  const [goToRobotArmHomePositionApi] =
    useGoToRobotArmHomePositionApiActionMutation();
  const [getRobotArmStatusApiAction] = useLazyGetRobotArmStatusApiActionQuery();
  const [updateRobotArmPositionApiAction] =
    useUpdateRobotArmPositionApiActionMutation();
  const [getRobotArmPositionApiAction] =
    useLazyGetRobotArmPositionApiActionQuery();

  const { isRobotArm } = useAppSelector((state) => state.booth);
  const { listTimesMappingCapturePosition } = useAppSelector(
    (state) => state.selfeApp,
  );

  const resetArmToHomePosition = useCallback(() => {
    if (isRobotArm && listCapturePosition?.data?.[0]) {
      const asyncUpdatePose = async () => {
        const statusRes = await getRobotArmStatusApiAction();
        if (checkIsIdleArm(statusRes?.data?.state)) {
          await goToRobotArmHomePositionApi();
        }
      };
      asyncUpdatePose();
    }
  }, [
    isRobotArm,
    getRobotArmStatusApiAction,
    goToRobotArmHomePositionApi,
    listCapturePosition?.data,
  ]);

  const handleMoveRobotArm = useBeautifulReactDebouncedCallback(
    async (capturePositionIndex: number = 0) => {
      if (
        isRobotArm &&
        listTimesMappingCapturePosition?.[capturePositionIndex]
      ) {
        const statusRes = await getRobotArmStatusApiAction();
        const armPositionRes = await getRobotArmPositionApiAction();
        if (
          checkIsIdleArm(statusRes?.data?.state) &&
          !checkSamePosition(
            armPositionRes?.data,
            listTimesMappingCapturePosition?.[capturePositionIndex],
          )
        ) {
          await updateRobotArmPositionApiAction(
            listTimesMappingCapturePosition?.[
              capturePositionIndex
            ] as RobotArmPositionWithCaptureNameModel,
          );
        }
      }
    },
    [isRobotArm],
    TIME_DEBOUNCE_UPDATE_ROBOT_ARM,
    { trailing: false, leading: true },
  );

  return {
    resetArmToHomePosition,
    handleMoveRobotArm,
  };
}
